import { Injectable } from '@angular/core';
import { UserProvider } from '../user/user';
import { User } from '../../models/User';
import { Platform } from 'ionic-angular';
import { StatusBar } from '@ionic-native/status-bar';

@Injectable()
export class IntercomProvider {

  public global: any = (<any> window); //Fancy name for window
  public unreadCount: number = 0;

  constructor(
    private userProvider: UserProvider, 
    private platform: Platform,
    private statusBar: StatusBar
  ) {
    //Get authenticated user - or not
    this.userProvider.getUser().subscribe(user => {
      if(user){
        this.bootIntercom(user);
      }else{
        this.bootIntercom(null);
      }
    })

  }

  bootIntercom(user: User){
    this.unreadCount = 0;
    this.global.Intercom('shutdown');
    if(user){
      this.global.Intercom('boot', {
        app_id: 'dnokb1xz',
        custom_launcher_selector: '#intercom-button',
        hide_default_launcher: true,
        'email': user.email,
        'user_id': user.uid,
        'phone': user.phoneNumber
      });
    }else{
      this.global.Intercom('boot', {
        app_id: 'dnokb1xz',
        custom_launcher_selector: '#intercom-button',
        hide_default_launcher: true 
      });
    }

    this.global.Intercom('onUnreadCountChange', count => {
      this.unreadCount = count;
    });

    if(this.platform.is('cordova')){
      this.global.Intercom('onShow', () => {
        this.statusBar.styleDefault();
      })

      this.global.Intercom('onHide', () => {
        this.statusBar.styleLightContent();
      })
    }

  }


}



// WEBPACK FOOTER //
// ./src/providers/intercom/intercom.ts